export const GET_PHONE_REGISTER_REQUESTED = 'GET_PHONE_REGISTER_REQUESTED';
export const GET_PHONE_REGISTER_SUCCESS = 'GET_PHONE_REGISTER_SUCCESS';
export const UPDATE_REGISTER_INFO_REQUESTED = 'UPDATE_REGISTER_INFO_REQUESTED';
export const UPDATE_REGISTER_INFO_SUCCESS = 'UPDATE_REGISTER_INFO_SUCCESS';
